export enum RiskFactorType {
  impact,
  probability,
  userDefined
}
